import Vue from 'vue'
import Vuex from 'vuex'
import Auth from '@/features/Auth/store'
import Arvore from '@/features/Arvore/store'
import CentroCusto from '@/features/Centro/store'
import Competencia from '@/features/Competencia/store'
import Formula from '@/features/Formula/store'
import Pergunta from '@/features/Pergunta/store'
import PerguntaGrupo from '@/features/PerguntaGrupo/store'
import Role from '@/features/Role/store'
import User from '@/features/User/store'
import Relatorio from '@/features/Relatorio/store'
import Seeder from '@/features/Seeder/store'
import Periodo from '@/features/Periodo/store'
import Indicador from '@/features/Indicador/store'
import Dashboard from '@/features/Dashboard/store'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'

Vue.use(Vuex)

const modules = {
  Auth,
  Arvore,
  Competencia,
  Formula,
  User,
  Role,
  Relatorio,
  Seeder,
  CentroCusto,
  Periodo,
  Dashboard,
  Indicador,
  Pergunta,
  PerguntaGrupo
}

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState()],
  state,
  actions: {
    ...actions
  },
  mutations:{
    ...mutations
  },
  getters:{
    ...getters
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js